import { TaggableComponent } from 'react-otmonitor-websocket';

class PowerplantRowAbstract extends TaggableComponent
{
    constructor(props)
    {
        super(props);
        this.bindTags([
            ['LostRemoteConnection'],
            ['WindSpeed'],
            ['OneWindSafety'],
            ['WindDirection'],
            ['WindDirectionDisplay'], 
            ['RabbitMQConnection'],
            ['MysqlReplication'],
            ['ActiveVPN'],
            ['ServicesStatus'],
            ['CtrlCpuLoad'],
            ['CtrlRamUsage'],
            ['CtrlDiskUsage'],
            ['SrvCpuLoad'],
            ['SrvRamUsage'],
            ['SrvDiskUsage'],
            ['PowerSimul'],
            ['NbTrackersOk'],
            ['NbTrackersManual'],
            ['NbTrackersError'],
            ['StuckWarningCounter'],
            ['AlarmWind']
        ]);
    }
    
    componentDidMount(prevProps, prevState)
    {
        super.componentDidMount(prevProps, prevState);
        if(this.props.powerplant.update(this.state)) {
            this.forceUpdate();
        }
    }

    componentDidUpdate(prevProps, prevState)
    {
        super.componentDidUpdate(prevProps, prevState);
        if(this.props.powerplant.update(this.state)) {
            this.forceUpdate();
            if(this.state.NbTrackersOk > 0) {
                this.props.refreshOnLoad();
            }
        }
    }
    
}

PowerplantRowAbstract.defaultProps = {
    app_id: null
}

export default PowerplantRowAbstract;